import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=0ce5ff17&"
import script from "./BlogPost.vue?vue&type=script&lang=js&"
export * from "./BlogPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jlamb/repos/roll20/d20app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce5ff17')) {
      api.createRecord('0ce5ff17', component.options)
    } else {
      api.reload('0ce5ff17', component.options)
    }
    module.hot.accept("./BlogPost.vue?vue&type=template&id=0ce5ff17&", function () {
      api.rerender('0ce5ff17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/blog-preview/src/components/BlogPost.vue"
export default component.exports